import { SettingsService } from './../settings.service';
import { NotificationService } from './../../../services/notification.service';
import { UserService } from './../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { TableString } from 'src/app/models/table-string.model';
import { User } from './models/user.model';
import { DropdownSelectionMode, DropdownValue, DropdownValues } from 'src/app/widgets/dropdown/dropdown.component';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss'],
	standalone: false
})
export class UserComponent implements OnInit {
	public usersSelectionData: TableString[];


	public usersSelectionDropdownData: DropdownValues = new DropdownValues();
	public selectedUserDropdownId: number;

	public selectedUser: User;
	public createdByUserName: string;
	public modifiedByUserName: string;

	public readAccessLevel: number = 200;
	public writeAccessLevel: number = 200;


	public rolesSelectionData: TableString[];

	emailButtonOptions: any;

	closeButtonOptions: any;

	constructor(
		private titleService: Title,
		private userService: UserService,
		private notificationService: NotificationService,
		private settingsService: SettingsService,
	) {
		this.emailButtonOptions = {
			icon: 'trash',
			text: 'Delete',
			onClick(e) {
				console.log("clcik");
			},
		};
		this.closeButtonOptions = {
			text: 'Close',
			onClick(e) {
				this.confirmationPopUpVisible = false;
			},
		};
	}

	ngOnInit() {
		this.initializeRolesSelectionDataNew();
		this.loadUserData();
	}

	public loadUserData() {
		console.log("loadUserData");
		const $this = this;
		this.initializeUserSelectionData().then(
			(response) => {
				$this.initializeUserData().then(
					(response) => {
						$this.initializeRolesSelectionData();
					}
				);
			}
		);
	}

	public selectUser(userId: number) {
		console.log("selectUser - userId:", userId);

		const $this = this;

		return this.userService.getUser(userId).toPromise().then(
			(response) => {
				console.log("selectUser -> getUser - response", response);

				$this.selectedUser = Object.assign(new User(), response);
				if ($this.usersSelectionData && $this.usersSelectionData != null
					&& $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.createdBy)) {
					$this.createdByUserName = $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.createdBy).value;
				}
				$this.modifiedByUserName = "";
				if ($this.usersSelectionData && $this.usersSelectionData != null
					&& $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.modiyBy)) {
					$this.modifiedByUserName = $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.modiyBy).value;
				}
				if ($this.rolesSelectionData) {
					$this.selectedUser.initialize($this.rolesSelectionData);
				}
				if ($this.selectedUser && $this.selectedUser.userID) {
					$this.selectedUserDropdownId = $this.selectedUser.userID;
				}

			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	public selectUserByName(userName: string) {
		console.log("selectUserByName - userName:", userName);

		const $this = this;

		return this.userService.getUserByName(userName).toPromise().then(
			(response) => {
				console.log("selectUserByName -> getUserByName - response", response);

				this.userName = '';
				this.password = '';

				$this.selectedUser = Object.assign(new User(), response);
				if ($this.usersSelectionData && $this.usersSelectionData != null
					&& $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.createdBy)) {
					$this.createdByUserName = $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.createdBy).value;
				}
				$this.modifiedByUserName = "";
				if ($this.usersSelectionData && $this.usersSelectionData != null
					&& $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.modiyBy)) {
					$this.modifiedByUserName = $this.usersSelectionData.find((tableString) => tableString.id === $this.selectedUser.modiyBy).value;
				}
				if ($this.rolesSelectionData) {
					$this.selectedUser.initialize($this.rolesSelectionData);
				}
				if ($this.selectedUser && $this.selectedUser.userID) {
					$this.selectedUserDropdownId = $this.selectedUser.userID;
				}

			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}


	public onUsersSelectionDataItemClick(event) {
		console.log("onUsersSelectionDataItemClick - event:", event);

		this.selectUser(event);

	}

	public initializeUserSelectionData() {
		console.log("initializeUserSelectionData");

		const observable$ = this.userService.getUsersSelectionData().toPromise();

		return observable$.then(
			(response) => {
				console.log("initializeUserSelectionData -> getUsersSelectionData - response:", response);

				this.usersSelectionData = response;

				this.usersSelectionDropdownData = new DropdownValues();
				this.usersSelectionDropdownData.selectionMode = DropdownSelectionMode.single;
				this.usersSelectionDropdownData.showClearButton = false;
				this.usersSelectionDropdownData.displayName = 'User';
				this.usersSelectionDropdownData.values = this.usersSelectionData.map(userSelectionData => new DropdownValue(userSelectionData.id, userSelectionData.value));
			},
			(error) => {
				console.error(error);

				this.notificationService.error(error);
			}
		);
	}

	public onRolesSelectionDataItemClick(event) {
		console.log("onRolesSelectionDataItemClick - event:", event);

		this.selectedUser.roleData = event.itemData;
	}

	public initializeRolesSelectionData() {
		console.log("initializeRolesSelectionData");

		const observable$ = this.settingsService.getRolesSelectionData().toPromise();

		return observable$.then(
			(response) => {
				console.log("initializeRolesSelectionData -> getRolesSelectionData - response:", response);

				this.rolesSelectionData = response;

				// User has to be selected first.
				this.selectedUser.initialize(this.rolesSelectionData);
			},
			(error) => {
				console.error(error);

				this.notificationService.error(error);
			}
		);
	}

	public initializeRolesSelectionDataNew() {
		const observable$ = this.settingsService.getRolesSelectionData().toPromise();
		return observable$.then(
			(response) => {
				this.rolesSelectionData = response;
			},
			(error) => {
				console.error(error);
				this.notificationService.error(error);
			}
		);
	}

	public initializeUserData() {
		console.log("initializeUserData");

		if (this.usersSelectionData && this.usersSelectionData.length > 0) {
			return this.selectUser(this.usersSelectionData[0].id);

		} else {
			console.warn(`Trying to initialize user data when this.usersSelectionData is not initilized.`);

			return null;
		}
	}

	public onUserSuccessfullyCreated(userName) {
		console.log("onUserSuccessfullyCreated - userName:", userName);

		const $this = this;

		this.initializeUserSelectionData().then(
			(response) => {
				$this.selectUserByName(userName);
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	public userName: string = '';
	public email: string = '';
	public password: string = '';

	public createUser() {
		const $this = this;

		this.userService.createUser(
			this.userName,
			this.email,
			this.password
		).subscribe(
			{
				next: (response) => {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = response.message;

					if (response.success) {
						$this.showNewUserPopup = false;

						$this.onUserSuccessfullyCreated(this.userName);
					} else {
					}
				},
				error: (error) => {
					console.error(error);

					// If it's a conflict.
					if (error.status === 409 && !error.error.success) {
						$this.showInfoPopup = true;
						$this.infoPopupMessage = error.error.message;
					} else {
						$this.notificationService.error(error);
					}
				}
			}
		);
	}

	public onUserSuccessfullySaved(userId) {
		console.log("onUserSuccessfullySaved - userId:", userId);

		const $this = this;

		$this.selectUser(userId);
	}

	public onSaveUserClicked() {
		console.log("onSaveUserClicked - selectedUser:", this.selectedUser);

		const $this = this;



		this.selectedUser.prepareForSave();

		console.log("onSaveUserClicked - prepared - selectedUser:", this.selectedUser);

		this.userService.saveUser(this.selectedUser).subscribe(
			(response) => {
				console.log("onSaveUserClicked -> saveUser - response:", response);

				

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;

				if (response.success) {
					$this.activityPopUpVisible = false;

					$this.onUserSuccessfullySaved($this.selectedUser.userID);
				}
			},
			(error) => {
				console.error(error);

				

				$this.showInfoPopup = true;
				$this.infoPopupMessage = error.error.message;

				$this.notificationService.error(error);
			}
		);
	}

	showNewUserPopup = false;
	public onCreateNewUserClicked() {
		console.log("onCreateNewUserClicked");
		this.showNewUserPopup = true;
	}

	public onDeleteUserClicked() {
		this.confirmationPopUpVisible = true;
	}

	public onDeleteUserConfrimButtonClicked() {
		console.log("onDeleteUserConfrimButtonClicked");

		const $this = this;

		this.userService.deleteUser(this.selectedUser.userID).subscribe(
			(response) => {
				console.log("onDeleteUserConfrimButtonClicked -> deleteUser - response:", response);

				$this.showInfoPopup = true;
				$this.infoPopupMessage = response.message;
				this.confirmationPopUpVisible = false;
				$this.loadUserData();
			},
			(error) => {
				console.error(error);
				this.confirmationPopUpVisible = false;
				// If it's a conflict.
				if (error.status === 409 && !error.error.success) {
					$this.showInfoPopup = true;
					$this.infoPopupMessage = error.error.message;
				} else {
					$this.notificationService.error(error);
				}
			}
		);
	}

	public onDeleteUserCancelButtonClicked() {
		console.log("onDeleteUserCancelButtonClicked");
	}

	// <Pop Ups>

	public activityPopUpVisible: boolean;

	public confirmationPopUpVisible: boolean = false;

	public showInfoPopup: boolean;
	public infoPopupMessage: string = "DEFAULT MESSAGE";

	public toggleInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
	}

	public sendEmail() {

		this.userService.sendEmail(this.selectedUserDropdownId).toPromise().then(resp => {
			console.log(resp);
			if (resp != null) {
				if (resp.statusFlag) {
					this.notificationService.success(resp.statusMsg);
				} else {
					this.notificationService.error(resp.statusMsg);
				}
			}
			else {
				this.notificationService.error("something went wrong. please try again later.");
			}
			this.resetPasswordPopUpVisible = false;
		}).catch((err) => {
			this.resetPasswordPopUpVisible = false;
			console.log(err, "test error");
		});
	}

	public popupchangePassVisible: boolean = false;
	public changePassword() {
		this.popupchangePassVisible = true;
	}
	public SavePassword(e) {
		this.popupchangePassVisible = false;
	}
	// </Pop Ups>


	//send email for user password
	resetPasswordPopUpVisible: boolean = false;
	resetPasswordConform(action: boolean = false) {
		if (action) {
			this.sendEmail();
		}
		else {
			this.resetPasswordPopUpVisible = false;
		}
	}

}
